<script setup lang="ts">
import { ref, onMounted, nextTick } from 'vue'

const props = defineProps<{
  modelValue: string
  label?: string
  placeholder?: string
  rows?: number
  error?: string
  autoFocus?: boolean
}>()

defineEmits<{
  'update:modelValue': [value: string]
}>()

const textareaRef = ref<HTMLTextAreaElement | null>(null)

onMounted(() => {
  if (props.autoFocus) {
    nextTick().then(() => {
      textareaRef.value?.focus()
    })
  }
})
</script>

<template>
  <div>
    <label v-if="label" class="block mb-2 text-subtext">{{ label }}</label>
    <textarea
      ref="textareaRef"
      :value="modelValue"
      :placeholder="placeholder"
      :rows="rows ?? 3"
      class="w-full p-2 text-sm bg-metal-800 border border-metal-700 hover:border-metal-600 rounded text-metal-300 placeholder-metal-500 focus:outline-none focus:ring-1 focus:ring-metal-700 focus:border-metal-500 resize-y"
      @input="$emit('update:modelValue', ($event.target as HTMLTextAreaElement).value)"
    ></textarea>
    <div v-if="error" class="pt-1 pb-1 text-red-500">{{ error }}</div>
  </div>
</template>
